// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileMarkdownOutlinedSvg from "@fishx/icons-svg/es/asn/FileMarkdownOutlined";
import FishxIcon from '../components/FishxIcon';

var FileMarkdownOutlined = function FileMarkdownOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileMarkdownOutlinedSvg
  }));
};

FileMarkdownOutlined.displayName = 'FileMarkdownOutlined';
export default React.forwardRef(FileMarkdownOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileMarkdownOutlined.js
// module id = 2724
// module chunks = 0